import script from "./TableLeadPropertyComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TableLeadPropertyComponent.vue?vue&type=script&setup=true&lang=js"

import "./TableLeadPropertyComponent.vue?vue&type=style&index=0&id=451d4e2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-451d4e2a"]])

export default __exports__